/**
 * Append query params to a URL
 * @param url original URL
 * @param name query param name
 * @param value query param value
 * @returns URL with appended query params
 */
export const appendQueryParam = (url: string, name: string, value: string) => {
  const urlObject = new URL(url);
  urlObject.searchParams.append(name, value);
  return urlObject.toString();
};

export const isMetaOsHelper = () => {
  const href = location.href;
  const convertedString = href.toLowerCase();

  if (convertedString.indexOf("metaos") === -1) {
    return false;
  }

  return true;
};

//https://learn.microsoft.com/en-us/javascript/api/@microsoft/teams-js/hostclienttype?view=msteams-client-js-latest
//https://learn.microsoft.com/en-us/javascript/api/@microsoft/teams-js/hostname?view=msteams-client-js-latest
export const isTeamsWin32 = () => {
  const params = new URL(document.location.toString()).searchParams;

  if (params !== undefined) {
    const hostClientType = params.get("hostClientType") ?? "web";
    const hostName = params.get("hostName");
    if (
      (hostName?.toLowerCase() === "teamsmodern" ||
        hostName?.toLowerCase() === "teams") &&
      hostClientType?.toLowerCase() === "desktop"
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

// “Harmony.Web.CopilotLab"
// "Harmony.Win32.CopilotLab"
// "Teams.Web.CopilotLab"
// "Teams.Win32.CopilotLab"
// "Outlook.Web.CopilotLab"
// "Outlook.Win32.CopilotLab"
export const GetScenarioName = () => {
  if (!isMetaOsHelper()) {
    return "Copilotlab.Web.Prompts";
  }

  const params = new URL(document.location.toString()).searchParams;

  if (params !== undefined) {
    let hostClientType = params.get("hostClientType") ?? "web";
    let hostName = params.get("hostName") ?? "";

    hostName = hostName.toLowerCase();
    hostClientType = hostClientType.toLowerCase();

    if (hostName === "office") {
      if (hostClientType === "web") {
        return "Harmony.Web.CopilotLab";
      }
      return "Harmony.Win32.CopilotLab";
    }

    if (hostName === "outlook" || hostName === "outlookwin32") {
      if (hostClientType === "web") {
        return "Outlook.Web.CopilotLab";
      }
      return "Outlook.Win32.CopilotLab";
    }

    if (hostName === "teams" || hostName === "teamsmodern") {
      if (hostClientType === "web") {
        return "Teams.Web.CopilotLab";
      }
      return "Teams.Win32.CopilotLab";
    }
  }

  return "Copilotlab.Web.Prompts";
};

// Updates the Meta tags which is used by Telemetry.
export const updateMetaTagFromIframe = (
  name: string,
  content: string
): void => {
  const element = document.querySelector(`meta[name="${name}"]`);
  if (element !== null) {
    element
      .querySelector(`meta[name="${name}"]`)
      ?.setAttribute("content", content);
  } else {
    const link = document.createElement("meta");
    link.setAttribute("name", name);
    link.setAttribute("content", content);
    document.getElementsByTagName("head")[0].appendChild(link);
  }
};
